export default __webpack_public_path__ + "84d14ae2952314bd8cf1f271664b3e44.png";